import type { RecurringExpense } from '@/lib/types';

function pad(value: number) {
  return String(value).padStart(2, '0');
}

export function recurringDateForMonth(item: RecurringExpense, year: number, monthIndex: number) {
  const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();
  const day = Math.min(Math.max(item.dayOfMonth ?? 1, 1), daysInMonth);
  return `${year}-${pad(monthIndex + 1)}-${pad(day)}`;
}
